export const REVISION_INTERVAL_KM = 10_000;

export enum RevisionStatusEnum {
  NOT_CONFIGURED = 'not_configured',
  UP_TO_DATE = 'up_to_date',
  OVERDUE = 'overdue',
}

export interface VehicleRevisionListItem {
  chassis: string;
  product_name: string | null;
  product_image: string | null;
  type: string;
  current_km: number;
  last_revision_km: number | null;
  revision_interval_km: number | null;
  next_revision_km: number | null;
  km_until_revision: number | null;
  revision_status: RevisionStatusEnum;
  is_configured: boolean;
  last_checklist_at: string | null;
}

export interface VehicleRevisionHistoryEntry {
  id: number;
  chassis: string;
  revision_km: number;
  interval_km: number;
  created_by_user_id?: number | null;
  created_by_user_name?: string | null;
  createdAt: string;
}

export interface VehicleRevisionDetail extends VehicleRevisionListItem {
  history: VehicleRevisionHistoryEntry[];
}

export interface VehicleRevisionConfigureParams {
  last_revision_km: number;
  revision_interval_km?: number;
}

export interface VehicleRevisionUpdateIntervalParams {
  revision_interval_km: number;
}

export interface VehicleRevisionRegisterParams {
  revision_km: number;
}

export interface VehicleRevisionOverdueSummary {
  total: number;
  items: VehicleRevisionListItem[];
}

export interface VehicleRevisionFindAllParams {
  pageIndex?: number;
  pageSize?: number;
  searchString?: string;
  status?: RevisionStatusEnum;
}
